// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transparentCover.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n", "",{"version":3,"sources":["webpack://./src/app/component/TransparentCover.less"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,oBAAA;AAAR","sourcesContent":[".transparentCover {\n    &.disabled {\n        opacity: 0.5;\n        pointer-events: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
